<template>
  <svg width="17" height="29" viewBox="0 0 17 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.41433 0.939331L16.8494 14.3744L14.728 16.4957L14.7171 16.485L3.06077 28.1421L0.939453 26.0208L12.5961 14.363L1.29301 3.06065L3.41433 0.939331Z" fill="#010101"/>
  </svg>
</template>